const selections = {
  make: '',
  series: '',
  chassis: '',
  model: '',
  engine: '',
  drivetrain: '',
  year: ''
}

const HOST = window.theme.host;

const makeSelection = (key, value) => {
  document.querySelectorAll(`.detailDrop[data-select="${key}"] .detailDropOptionSelection`).forEach(a => a.classList.remove('active'));
  document.querySelector(`.detailDrop[data-select="${key}"] .detailDropOptionSelection[data-value="${value}"]`).classList.add('active');
  document.querySelector(`.detailDrop[data-select="${key}"] .detailDropSelect`).classList.remove('open');
  document.querySelector(`.detailDrop[data-select="${key}"] .detailDropOptions`).style.height = 0;
  document.querySelector(`.detailDrop[data-select="${key}"] .detailDropSelect p`).textContent = value;
  if (!value) {
    document.querySelector(`.detailDrop[data-select="${key}"]`).classList.add('blank');
  } else {
    document.querySelector(`.detailDrop[data-select="${key}"]`).classList.remove('blank');
  }

  const keys = Object.keys(selections);
  const index = keys.indexOf(key);
  const nextSelection = keys[index + 1];

  keys.forEach((k, i) => {
    if (i === index) {
      selections[k] = value;
    }
    if (i > index) {
      selections[k] = '';
      document.querySelector(`.detailDrop[data-select="${k}"]`).classList.remove('active');
      document.querySelector(`.detailDrop[data-select="${k}"]`).classList.remove('blank');
      document.querySelector(`.detailDrop[data-select="${k}"] .detailDropSelect p`).textContent = 'Select ' + k[0].toUpperCase() + k.slice(1);
      if (k !== 'year') {
        document.querySelector(`.detailDrop[data-select="${k}"] .detailDropOptions`).innerHTML = '';
      }
    }
  });

  if (nextSelection) {
    document.querySelector(`.detailDrop[data-select="${nextSelection}"]`).classList.add('active');
    if (nextSelection !== 'year') {
      getNextSelections(nextSelection);
    }
  }
}

const getNextSelections = nextSelection => {
  let nextSelections = [];
  const indexOfNext = Object.keys(selections).indexOf(nextSelection);
  const currentSelections = Object.values(selections).slice(0, indexOfNext);
  const allNextSelections = carModelsArray.filter(arr => currentSelections.every((val, i) => arr[i] === val));
  allNextSelections.forEach(arr => {
    const value = arr[currentSelections.length];
    if (nextSelections.indexOf(value) === -1) {
      nextSelections.push(value);
    }
  });
  const container = document.querySelector(`.detailDrop[data-select="${nextSelection}"] .detailDropOptions`);
  nextSelections.forEach(val => {
    const a = document.createElement('a');
    a.dataset.value = val;
    a.textContent = val;
    a.className = 'detailDropOptionSelection';
    container.append(a);
    if (nextSelections.length === 1) {
      a.click();
    }
  });
}

const setMakes = () => {
  let makes = [];
  carModelsArray.forEach(arr => {
    const make = arr[0];
    if (makes.indexOf(make) === -1) {
      makes.push(make);
    }
  });
  const container = document.querySelector('.detailDrop[data-select="make"] .detailDropOptions');
  makes.forEach(make => {
    const a = document.createElement('a');
    a.dataset.value = make;
    a.textContent = make;
    a.className = 'detailDropOptionSelection';
    container.append(a);
  });
}

const setYears = () => {
  const latestYear = new Date().getFullYear() + 1;
  const container = document.querySelector('.detailDrop[data-select="year"] .detailDropOptions');
  for (i = latestYear; i >= 1975; i--) {
    const a = document.createElement('a');
    a.dataset.value = i;
    a.textContent = i;
    a.className = 'detailDropOptionSelection';
    container.append(a);
  }
}

document.querySelectorAll('.detailDropSelect').forEach(btn => btn.addEventListener('click', e => {
  e.preventDefault();
  const container = e.currentTarget.closest('.detailDrop');
  const drop = container.querySelector('.detailDropOptions');
  if (e.currentTarget.classList.contains('open')) {
    e.currentTarget.classList.remove('open');
    drop.style.height = 0;
  } else {
    e.currentTarget.classList.add('open');
    drop.style.height = drop.scrollHeight + 'px';
  }
}));

document.querySelector('.CarProfile__carDetails').addEventListener('click', e => {
  if (e.target.classList.contains('detailDropOptionSelection')) {
    e.preventDefault();
    const key = e.target.closest('.detailDrop').dataset.select;
    makeSelection(key, e.target.dataset.value);
  }
});

document.querySelector('.CarProfile__form').addEventListener('submit', async e => {
  e.preventDefault();
  let valid = true;
  const data = {
    first_name: document.querySelector('#first_name').value,
    last_name: document.querySelector('#last_name').value,
    email: document.querySelector('#email').value,
    igName: document.querySelector('#igName').value,
    carDetails: selections
  };
  Object.keys(data).forEach(key => {
    if (key !== 'igName' && key !== 'carDetails') {
      if (!data[key]) {
        document.getElementById(key).style.borderColor = 'red';
        valid = false;
      } else {
        document.getElementById(key).style.borderColor = '#000';
      }
    }
  });

  Object.keys(data.carDetails).forEach(key => {
    if (!data.carDetails[key]) {
      const selectorNotNeeded = document.querySelector(`.detailDrop[data-select="${key}"]`).classList.contains('blank');
      if (!selectorNotNeeded) {
        document.querySelector(`.detailDrop[data-select="${key}"] .detailDropSelect`).style.borderColor = 'red';
        valid = false;
      }

    } else {
      document.querySelector(`.detailDrop[data-select="${key}"] .detailDropSelect`).style.borderColor = '#000';
    }
  });
  
  if (valid) {
    const currentSelections = Object.values(selections);
    currentSelections.pop();
    const allNextSelections = carModelsArray.find(arr => currentSelections.every((val, i) => arr[i] === val));
    data.selectedCar = allNextSelections[9];
    data.collectionHandle = allNextSelections[6];

    try {
      document.querySelector('.CarProfile__btns .next').disabled = true;
      const response = await axios.post(`${HOST}/create_customer`, data, {headers: {
        shop: window.theme.shop
      }});

      if (response.data.accountExists) {
        document.querySelector('.errorMessageEmail').textContent = response.data.accountExists;
        document.querySelector('.errorMessage').style.display = 'block';
        document.querySelector('.CarProfile__btns .next').disabled = false;
      } else {
        window.location.href = response.data.activation;
      }

    } catch(e) {
      document.querySelector('.CarProfile__btns .next').disabled = false;
      console.log('Error creating customer', e);
    }

  }
});

setMakes();
setYears();